import { useLDClient, useLDClientError } from 'launchdarkly-react-client-sdk';

// Web: `LDProvider` fills context asynchronously after mount. Until then, `useLDClient()` is undefined.
export function useLaunchDarklyClientReady(): boolean {
  const client = useLDClient();
  const error = useLDClientError();
  return client !== undefined || error !== undefined;
}
